import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";

const ImageWithLeftCard = ({ t, image, link }) => {
  const [language, setLanguage] = useState(Cookies.get("RashaLang") || "en");

  useEffect(() => {
    const interval = setInterval(() => {
      const currentLang = Cookies.get("RashaLang") || "en";
      setLanguage((prev) => (prev !== currentLang ? currentLang : prev));
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const isArabic = language === "ar";
  const layoutClass = isArabic ? "rtl-wrapper" : "";
  const textAlignClass = isArabic ? "text-right" : "";

  const { title, heading, paragraph, button } = t[language];

  return (
    <div className={`container ${textAlignClass}`}>
      {title !== "" ? <h1>{title}</h1> : ""}

      <div className={`wrapper ${layoutClass}`}>
        {!isArabic && (
          <div className="child">
            <h3>
              {heading.split("\n").map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </h3>
            <hr />
            <p>{paragraph}</p>
            <button
              className="living-button"
              onClick={() => (window.location.href = link)}
            >
              {button}
            </button>
          </div>
        )}
        <img src={image} alt="Living" className="background-image" />
        {isArabic && (
          <div className="child">
            <h3>
              {heading.split("\n").map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </h3>
            <hr />
            <p>{paragraph}</p>
            <button
              className="living-button"
              onClick={() => (window.location.href = link)}
            >
              {button}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImageWithLeftCard;
